/** The csrf_token cookie is readable on purpose (double-submit). Read it per request; never store it. */
export function readCsrfToken(): string | undefined {
  const match = document.cookie.split("; ").find((c) => c.startsWith("csrf_token="));
  return match ? decodeURIComponent(match.slice("csrf_token=".length)) : undefined;
}
